<template>
	<v-card class="elevation-0 events-page page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<div class="events-page__wrap">
				<FilterChipButtons
					:isButtonActive="isButtonActive"
					:chipsList="chipsList"
					:clearFilter="clearFilter"
					@handleChipClick="handleChipClick"
				/>

				<div v-if="filterModalIsVisible">
					<FilterModal
						:filterModalIsVisible="filterModalIsVisible"
						:currentModalFilter="currentModalFilter"
						:currentModalLabel="currentModalLabel"
						:selectedChips="selectedChips"
						:filters="filters"
						:dateError="date.error"
						:dateOption="date.option"
						:dateRange="date.selectedRange"
						@closeModal="closeModal"
						@applySelection="applySelection"
						@setItem="setItem"
					/>
				</div>
			</div>

			<Banner v-if="banner && !isLoading" :banner="banner" :mt="20" />

			<div class="d-flex">
				<v-skeleton-loader
					v-if="isLoading"
					v-bind="attrs"
					max-width="555"
					width="100%"
					type="list-item, list-item-three-line, card-heading"
				/>
				<div v-else style="width: 100%" class="events_box">
					<div v-if="events.length === 0" class="mt-5">
						<NewsFeedEmpty
							title="Events is empty at the moment."
							description="Check back later."
						/>
					</div>
          <div v-for="({ date, data }, i) in EventsBlockGroup" :key="`${date}-${i}`">
            <div class="events-page__title">
              {{ date }}
            </div>
            <div v-for="eventInfo in data" :key="eventInfo.event_id">
              <EventPreview :eventInfo="eventInfo" @tagClicked="handleTagClick" />
            </div>
          </div>
        </div>
			</div>

			<div
				class="d-flex my-9 justify-center home-page__pagination"
				v-if="!isLoading && events.length > 0"
			>
				<Pagination
					:page="filters.page"
					:pageCount="+this.pageCountEvents"
					v-on:pageChange="onPageChange"
				/>
			</div>

			<v-btn v-show="isVisible" @click="scrollToTop" bottom right fixed fab>
				<v-icon>mdi-chevron-up</v-icon>
			</v-btn>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import EventPreview from '@/components/Event/EventPreview'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import Pagination from '@/components/Pagination.vue'
import Block from '@/mixins/Block.js'
import PageBlocked from '@/components/PageBlocked'
import FilterChipButtons from '@/components/FilterChipButtons.vue'
import Filter from '@/mixins/Filter'
import FilterModal from '@/components/Modals/FilterModal'
import Banner from '@/components/Banner'

export default {
	name: 'EventsPage',
	mixins: [Block, Filter],
	components: {
		FilterChipButtons,
		EventPreview,
		NewsFeedEmpty,
		Pagination,
		PageBlocked,
		FilterModal,
		Banner,
	},
	methods: {
		...mapActions('event', ['fetchEvents', 'clearEventCategories']),
		...mapActions('advertisement', ['getBanner', 'clearBanner']),
		...mapActions('app', ['setPageTitle']),
		handleTagClick(tagId) {
			if (!this.selectedChips.tags) {
				this.$set(this.selectedChips, 'tags', [])
			}
			if (this.selectedChips.tags.includes(tagId)) {
				this.selectedChips.tags = this.selectedChips.tags.filter((id) => id !== tagId)
			} else {
				this.selectedChips.tags.push(tagId)
			}
			this.currentModalFilter = 'tags'
			this.getFilteredItems()
		},

		toggleVisibility() {
			this.isVisible = window.scrollY > 1000
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			})
		},
	},

	created() {
		if (!this.isBlocked || this.isBlocked === null) {
			this.fetchEvents(this.requestQuery)
			const bannerQuery = {
				places: ['event_list'],
				page: this.filters.page,
			}
			if (this.selectedChips.chapters && this.selectedChips.chapters.length) {
				bannerQuery.chapter_id = this.selectedChips.chapters
			}
			this.getBanner(bannerQuery)
		}
	},

	computed: {
		...mapGetters('event', ['events', 'isLoading', 'pageCountEvents']),
		...mapGetters('settings', ['eventSettings']),
		...mapGetters('advertisement', ['banner']),
    eventsBlock() {
      return this.events.map((event) => {
        if (!event || !Array.isArray(event.eventsList)) return null
        const block = event.eventsList.find((b) => b.block_name === 'eventInfo')
        return block ? block.block_data : null
      })
    },
    EventsBlockGroup() {
      const result = []
      this.eventsBlock.forEach((event) => {
        const fromDate = new Date(event.event_start * 1000)
        const month = fromDate.toLocaleString('en-US', { month: 'long' })
        const year = fromDate.getFullYear()
        const key = `${month} ${year}`
        if (result.length === 0) {
          result.push({
            date: key,
            data: [event],
          })
        } else {
          const lastGroup = result[result.length - 1]
          if (lastGroup.date === key) {
            lastGroup.data.push(event)
          } else {
            result.push({
              date: key,
              data: [event],
            })
          }
        }
      })
      return result.map(({ date, data }) => ({ date, data }))
    },
	},

	mounted() {
		window.addEventListener('scroll', this.toggleVisibility)
		this.setPageTitle('Events')
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.toggleVisibility)
		this.clearEventCategories()
		this.clearBanner()
		this.setPageTitle('')
	},

	data() {
		return {
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			isVisible: false,
			pageBlockedName: 'events',
		}
	},
}
</script>

<style lang="scss">
.events-page {
	background: #f1f1f1 !important;
	max-width: 600px;
	width: 100%;
  &__title {
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0;
    color: #4a4a4a;
    margin-top: 20px;
    margin-bottom: 8px;

  }

	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}

	&__time {
		color: rgb(74, 74, 74);
		font-size: 24px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	.event {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
			max-width: 600px;
		}

		&__filters {
			color: white;
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			letter-spacing: 0.36px;
			margin-top: 20px;
			background: rgb(65, 161, 216) !important;
			border-radius: 15px;
			box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
			text-transform: capitalize !important;
			align-items: center;
		}

		@media screen and (max-width: 1264px) {
			&__search {
				max-width: none;
			}
		}
	}

	.post {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
			max-width: 600px;
		}

		@media screen and (max-width: 1264px) {
			&__search {
				max-width: none;
				width: 100%;
			}
		}
	}
}
</style>
